<template>
  <div>
    <material-card
      :title="
        $t('components.vuematerialdashboard.core.appbar.claims_management')
      "
      :color="$vuetify.theme.themes.light.secondary"
      icon="description"
      v-if="plans && options"
    >
      <template v-slot:actions>
        <div style="margin-right: 20px; margin-top: 10px">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" dark>
                <v-icon>more_vert</v-icon>
                {{
                  $t("components.claims.claims_history_component.submit_claims")
                }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="newClaimSubmission('Health')">
                <v-list-item-title>
                  <!-- <v-icon small class="mr-2">view_column</v-icon> -->
                  {{
                    $t(
                      "components.claims.claims_history_component.submit_health_claim"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="newClaimSubmission('Prescription')">
                <v-list-item-title>
                  <!-- <v-icon small class="mr-2">file_download</v-icon> -->
                  {{
                    $t(
                      "components.claims.claims_history_component.submit_prescription_claim"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="newClaimSubmission('Dental')">
                <v-list-item-title>
                  <!-- <v-icon small class="mr-2">
                    {{ action.icon }}
                  </v-icon> -->
                  {{
                    $t(
                      "components.claims.claims_history_component.submit_dental_claim"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                @click="newClaimSubmission('HSA')"
                v-if="
                  memberIdentityId === null ||
                  memberIdentityId === undefined ||
                  memberHasHSA !== false
                "
              >
                <v-list-item-title>
                  {{
                    $t(
                      "components.claims.claims_history_component.submit_hsa_claim"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="newClaimSubmission('SickDay')">
                <v-list-item-title>
                  {{
                    $t(
                      "components.claims.claims_history_component.submit_sick_day_claim"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <flag-claims-dialog
        :items="claimsToPrint.map((o) => o.Id)"
        :model="flagsDialog"
        @close="closeFlagsDialog"
      />
      <v-container fluid>
        <v-row>
          <v-col
            cols="auto"
            class="note-text ma-2 mb-4 ml-4 mr-0 pr-0 text-left"
          >
            {{ $t("components.claims_history.tab.submitted") }}
          </v-col>
        </v-row>
        <v-form v-model="valid">
          <v-row no-gutters class="search">
            <v-col cols="12" sm="6" md="3" class="pa-4 pt-0">
              <v-autocomplete
                name="plans"
                :menu-props="{ contentClass: 'text-left benefits' }"
                dense
                :label="$t('globals.plan')"
                v-model="claimPlan"
                :items="plans.filter((o) => o.PlanType === 'HW')"
                :item-text="planDescription"
                item-value="Id"
                @input="searchPlan"
                clearable
                return-object
                :rules="[$rules.required]"
                class="required"
                outlined
                :disabled="
                  memberIdentityId !== null && memberIdentityId !== undefined
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pa-4 pt-0">
              <v-select
                :menu-props="{ contentClass: 'text-left' }"
                name="date-range"
                outlined
                dense
                v-model="selectedDateRange"
                @input="searchByDateRange"
                :items="dateRanges"
                item-text="text"
                item-value="range"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="pa-4 pl-0 pt-0"
              v-if="isCustomDateRange"
            >
              <v-menu
                v-model="showDatepicker"
                :nudge-right="40"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                left
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    :label="$t('components.claims_history.submission_dates')"
                    name="expenseDate"
                    append-icon="mdi-calendar"
                    dense
                    outlined
                    @click:append="showDatepicker = true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  no-title
                  v-model="customSelectedDateRange"
                  :max="$helpers.toISOStringLocal(new Date())"
                  range
                ></v-date-picker>
              </v-menu>
            </v-col>
            <template
              v-if="memberIdentityId === null || memberIdentityId === undefined"
            >
              <v-col cols="12" sm="6" md="3" class="pa-4 pt-0">
                <trans-select3
                  outlined
                  dense
                  :value.sync="selectedEmployer"
                  :items="filteredEmployers"
                  :label="$t('globals.employers')"
                  field="Name"
                  item-value="IdentityId"
                  @input="onEmployerSearch"
                  clearable
                ></trans-select3>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pa-4 pt-0">
                <trans-multi-select2
                  outlined
                  dense
                  v-model="selectedMemberGroups"
                  :items="filteredMemberGroups"
                  :label="$t('globals.member_groups')"
                  field="Name"
                  itemValue="IdentityId"
                  @input="onMemberGroupSearch"
                ></trans-multi-select2>
              </v-col>
            </template>
            <v-spacer></v-spacer>

            <v-col cols="auto" class="pr-4">
              <v-btn
                height="40"
                text
                class="rounded-lg px-5"
                @click="reset"
                :disabled="claimPlan === null || claimPlan === undefined"
              >
                <span
                  :class="`
                  text-subtitle-2 text-md-subtitle-1
                  claim-btn`"
                >
                  {{ $t("globals.reset") }}
                </span>
              </v-btn>
            </v-col>
            <v-col cols="auto" class="pr-4" v-if="claimsToPrint.length > 0">
              <v-btn color="primary" dark @click="printSelected">
                {{ $t("components.claims_history.print_selected") }}
              </v-btn>
            </v-col>
            <v-col cols="auto" class="pr-4" v-if="claimsToPrint.length > 0">
              <v-btn color="primary" @click="flagsDialog = true">
                {{ $t("components.claims_history.flag_selected") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

        <template v-if="claimPlan">
          <submitted-claims-search-form
            :loading="loading"
            :reset="resetSearch"
            @search="onSearch($event, null)"
            @reset-search="reset"
            :planIdentityId="claimPlan.Id"
            :certificateLength="claimPlan.CertificateLength.toString()"
            :memberGroupIdentityIds="
              selectedMemberGroups.map((o) => o.IdentityId)
            "
          />
          <submitted-submissions-table
            ref="sst"
            :loading="loading"
            :claims="submittedClaims"
            :totalCount="totalCountSubmitted"
            :reset="resetSearch"
            @pagination="onSearch(null, $event)"
            @claims-selected="setPrintItems"
            @preview-proof="previewProof"
            @reload="onSearch"
            @print-predetermination="setPrintPreData"
            @print-eob="setPrintEobData"
            @print-selected="printSelected"
          />
        </template>
      </v-container>
    </material-card>

    <error-handler :error="error"></error-handler>

    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      {{ successMessage }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>

    <file-preview-base64
      :fullScreen="false"
      v-if="preview"
      :view="preview"
      :fileItems="fileItems"
      @close="closePreview"
    />

    <v-dialog v-model="generatePrintout" max-width="800">
      <v-card class="pa-5" width="800">
        <v-card-text>
          {{ $t("components.claim_submission.confirmation.preparing") }}
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card-text>
        <div id="print-claims" v-if="generatePrintout">
          <claims-printout
            :claims="claimsToPrint"
            :dates="selectedDateRange"
            :headers="printoutTableHeaders"
            :title="printoutTitle"
            :planName="getPlanName(claimPlan)"
            @loaded="printClaims"
          />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="predeterminationPrintDialog" max-width="800">
      <v-card class="pa-5" width="800">
        <v-card-text>
          {{ $t("components.claim_submission.confirmation.preparing") }}
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card-text>
        <div id="print-claims-pre" v-if="predeterminationPrintDialog">
          <claims-printout-pre
            :claim="claimToPrintPre"
            :dates="selectedDateRange"
            :headers="printoutTableHeadersPre"
            :title="printoutTitlePre"
            :planName="getPlanName(claimPlan)"
            :planNumber="getPlanNumber(claimPlan)"
            @loaded="printPredetermination"
          />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="eobPrintDialog" max-width="800">
      <v-card class="pa-5" width="800">
        <v-card-text>
          {{ $t("components.claim_submission.confirmation.preparing") }}
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card-text>
        <div id="print-claims-eob" v-if="eobPrintDialog">
          <claims-printout-eob
            :claim="claimToPrintEob"
            :headers="printoutTableHeadersEob"
            :title="printoutTitleEob"
            :planName="getPlanName(claimPlan)"
            @loaded="printEob"
            :planNumber="getPlanNumber(claimPlan)"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubmittedSubmissionsTable from "@/components/Claims/SubmittedSubmissionsTable.vue";
import SubmittedClaimsSearchForm from "@/components/Claims/SubmittedClaimsSearchForm.vue";
import ClaimsPrintout from "@/components/Claims/ClaimsPrintout.vue";
import ErrorHandler from "@/components/ErrorHandler.vue";
import mockSubmittedClaims from "./mockSubmittedClaimsData.json";
import FilePreviewBase64 from "@/components/Claims/FilePreviewBase64.vue";
import html2pdf from "html2pdf.js";
import { printFileFromBase64 } from "@/printFileFromBase64";
import { translate2 } from "@/trans2";
import { previewProofHandler } from "@/mixins/previewProofHandler";
import FlagClaimsDialog from "@/components/Claims/FlagClaimsDialog.vue";
import ClaimsPrintoutPre from "@/components/Claims/ClaimsPrintoutPre.vue";
import ClaimsPrintoutEob from "@/components/Claims/ClaimsPrintoutEOB.vue";
import TransMultiSelect2 from "@/components/TransMultiSelect2";
import { sortAlphanum } from "@/alphanumericSort";
import isEqual from "lodash/isEqual";
import TransSelect3 from "../TransSelect3.vue";

export default {
  components: {
    SubmittedSubmissionsTable,
    SubmittedClaimsSearchForm,
    ErrorHandler,
    FilePreviewBase64,
    ClaimsPrintout,
    FlagClaimsDialog,
    ClaimsPrintoutPre,
    ClaimsPrintoutEob,
    TransMultiSelect2,
    TransSelect3,
  },
  mixins: [previewProofHandler],
  props: ["memberIdentityId", "memberHasHSA"],
  data() {
    return {
      resetSearch: false,
      showDatepicker: false,
      selectedDateRange: null,
      customSelectedDateRange: [],
      isCustomDateRange: false,
      error: undefined,
      snackbar: false,
      successMessage: "",
      loading: false,
      sortBy: "",
      orderBy: "",
      limit: "10",
      status: "",
      searchData: [],
      noSearchData: false,
      submittedClaims: [],
      totalCountSubmitted: 0,
      searchParams: {
        patient: null,
      },
      printFileFromBase64: printFileFromBase64,
      tableOptions: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
      },
      mockSubmittedClaims: mockSubmittedClaims,
      preview: false,
      fileItems: null,
      claimsToPrint: [],
      generatePrintout: false,
      printoutTableHeaders: [],
      printoutTitle: [],
      claimPlan: null,
      flagsDialog: false,
      claimToPrintPre: [],
      predeterminationPrintDialog: false,
      printoutTableHeadersPre: [],
      printoutTitlePre: [],
      claimToPrintEob: [],
      eobPrintDialog: false,
      printoutTableHeadersEob: [],
      printoutTitleEob: [],
      employers: [],
      memberGroups: [],
      selectedEmployer: null,
      selectedMemberGroups: [],
      searchMonitor: null,
      valid: false,
    };
  },
  watch: {
    valid: {
      handler(v) {
        if (v) {
          this.onSearch();
        }
      },
    },
    selectedEmployer: {
      handler(v) {
        if (v) {
          this.selectedMemberGroups = this.filteredMemberGroups;
          if (this.selectedMemberGroups.length > 0) {
            this.onSearch();
          }
        }
      },
    },
    claimPlan: {
      handler(v) {
        console.log(v, this.memberIdentityId);
        this.searchParams.coverages = [];
        this.setClaimsPlan(v);
        // if (
        //   this.memberIdentityId !== null &&
        //   this.memberIdentityId !== undefined
        // ) {
        //   this.onSearch();
        // }
      },
    },
    // filteredEmployers: {
    //   handler(v) {
    //     if (!v) {
    //       return;
    //     }
    //     if (!isEqual(this.selectedEmployer, v)) {
    //       this.selectedEmployer = v;
    //     }
    //   },
    // },
    // filteredMemberGroups: {
    //   handler(v) {
    //     if (!v) {
    //       return;
    //     }
    //     if (!isEqual(this.selectedMemberGroups, v)) {
    //       this.selectedMemberGroups = v;
    //     }
    //   },
    // },
    customSelectedDateRange: {
      handler(v) {
        if (v !== null && v !== undefined && v.length > 1) {
          console.log(v);
          this.searchCustomDateRange();
        }
      },
    },
  },
  computed: {
    ...mapGetters("common", ["plans", "claimsPlan", "language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["user"]),
    ...mapGetters("plansMembers", ["options"]),
    dateRanges() {
      const dateRanges = [
        {
          text: this.$t("components.claims_history.last6"),
          range: this.$helpers.dateRangesMonths(6),
        },
        {
          text: this.$t("components.claims_history.last3"),
          range: this.$helpers.dateRangesMonths(3),
        },
        {
          text: this.$t("components.claims_history.last1"),
          range: this.$helpers.datesLastMonthsOnly(),
        },
        {
          text: this.$t("components.claims_history.last30days"),
          range: this.$helpers.dateRangesMonths(1),
        },
        {
          text: this.$t("components.claims_history.all_for_this_year"),
          range: this.$helpers.dateRangesForYear(this.$helpers.thisYear()),
        },
        {
          text: this.$t("components.claims_history.all_for_last_year"),
          range: this.$helpers.dateRangesForYear(this.$helpers.thisYear(-1)),
        },
        {
          text: this.$t("components.claims_history.custom"),
          range: "custom",
        },
        {
          text: this.$t("globals.all"),
          range: null,
        },
      ];
      return dateRanges;
    },
    dateRangeText: {
      get() {
        return this.customSelectedDateRange.join(" ~ ");
      },
      set(dates) {
        return dates;
      },
    },
    filteredEmployers() {
      if (this.selectedMemberGroups.length === 0) {
        return this.employers;
      }
      return this.employers.filter((o) =>
        this.selectedMemberGroups.some((g) =>
          g.Employers.some((ge) => ge.Current.Id === o.Id)
        )
      );
    },
    filteredMemberGroups() {
      if (
        this.selectedEmployer === null ||
        this.selectedEmployer === undefined
      ) {
        return this.memberGroups;
      }
      return this.memberGroups.filter((o) =>
        o.Employers.some((ge) => ge.Current.Id === this.selectedEmployer.Id)
      );
    },
  },
  async mounted() {
    this.selectedDateRange = this.$helpers.dateRangesMonths(6);
    this.loadUserPlans();
  },
  methods: {
    ...mapActions("claims", ["searchClaims"]),
    ...mapActions("plansMembers", [
      "getUserPlans",
      "getEmployersDateRange",
      "getMemberGroupsDateRange",
    ]),
    ...mapActions("auth", ["silentRefresh", "login"]),
    ...mapActions("common", ["setPlans", "setClaimsPlan"]),
    ...mapActions("documentsService", ["getFile"]),
    async loadEmployersAndGroups(planIdentityId) {
      if (planIdentityId === null || planIdentityId === undefined) {
        this.memberGroups = [];
        this.employers = [];
        return;
      }
      let submissionDates = this.customSelectedDateRange.length
        ? this.customSelectedDateRange
        : this.selectedDateRange;
      let dateRangeFilter = "";
      if (submissionDates !== null && submissionDates !== undefined) {
        const startDateIncluding = submissionDates[0];
        const endDateIncluding = submissionDates[1];
        dateRangeFilter = `EffectiveDate ge ${startDateIncluding}T23:59:59.999999Z and EffectiveDate le ${endDateIncluding}T23:59:59.999999Z`;
      }

      try {
        this.loading = true;
        this.employers = (
          await this.getEmployersDateRange({
            planIdentityId: planIdentityId,
            query: dateRangeFilter,
          })
        ).data.value;

        this.memberGroups = (
          await this.getMemberGroupsDateRange({
            planIdentityId: planIdentityId,
            query: `${dateRangeFilter}&$expand=Employers($expand=Current)`,
          })
        ).data.value;
        // if (this.member.EmploymentInfo.Employer) {
        // for (let employer of this.employers) {
        //   let employerGroups = [];
        //   for (let mg of this.memberGroups) {
        //     if (mg.Employers && mg.Employers.length > 0) {
        //       if (mg.Employers.some((o) => o.Id === employer.Id)) {
        //         // console.log("employer: ", employer);
        //         // console.log("mg: ", mg);
        //         employerGroups.push(mg);
        //       }
        //     }
        //   }
        //   if (employerGroups.length > 0) {
        //     employer.MemberGroups = JSON.parse(JSON.stringify(employerGroups));
        //   } else {
        //     employer.MemberGroups = JSON.parse(
        //       JSON.stringify(this.memberGroups)
        //     );
        //   }
        // }
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    planDescription(plan) {
      const desc = translate2(plan, "Name");
      if (desc.indexOf(plan.UniqueIdentifier) === 0) {
        return desc;
      }
      return plan.UniqueIdentifier + "-" + desc;
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    closeFlagsDialog(flags) {
      if (flags) {
        this.onSearch();
      }
      this.flagsDialog = false;
    },
    isChanged() {
      console.log("chc: ", this.$refs.sst);
      return (
        (this.$refs.sst && this.$refs.sst.isChanged()) ||
        (!this.$refs.sst && false)
      );
    },
    async loadUserPlans() {
      try {
        this.loading = true;
        var usr = await this.silentRefresh();
        if (usr) {
          let plans = (await this.getUserPlans()).data.value;
          this.setPlans(
            plans.map((o) => {
              o.Name = o.Current.Name;
              o.Description = o.Current.Description;
              o.Translations = o.Current.Translations;
              return o;
            })
          );
          if (this.claimsPlan !== null && this.claimsPlan !== undefined) {
            this.claimPlan = this.claimsPlan;
          } else {
            this.claimPlan = this.selectedPlan;
          }
          if (this.claimPlan !== null && this.claimPlan !== undefined) {
            this.searchPlan(this.claimPlan);
          }
        }
      } catch (error) {
        //console.log("selectPlan: silent refresh error: ", error);
        this.login();
      } finally {
        this.loading = false;
      }
    },
    getPlanName(item) {
      // console.log(item);
      return translate2(item, "Name");
    },
    getPlanNumber(item) {
      // console.log(item);
      return item.UniqueIdentifier;
    },

    async searchPlan(plan) {
      if (plan === null || plan === undefined) {
        this.employers = [];
        this.memberGroups = [];
      } else {
        await this.loadEmployersAndGroups(plan.Id);
      }
      this.onSearch();
    },

    async searchByDateRange(range) {
      if (range === "custom") {
        this.isCustomDateRange = true;
      } else {
        this.isCustomDateRange = false;
        await this.loadEmployersAndGroups(this.claimPlan.Id);
        this.onSearch();
      }
    },
    async searchCustomDateRange() {
      await this.loadEmployersAndGroups(this.claimPlan.Id);
      this.onSearch();
    },
    onMemberGroupSearch(memberGroups) {
      console.log("mg change", memberGroups);
      // if (memberGroups.length > 0) {
      this.onSearch();
      // }
    },
    onEmployerSearch(employers) {
      console.log(employers);
    },
    async onSearch(params, options) {
      const obj = {};
      this.searchMonitor = obj;
      await this.delay(800);
      if (this.searchMonitor !== obj) {
        return;
      }
      this.search(params, options);
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async search(searchParams, options) {
      console.log("search called: ", searchParams, options);
      if (this.claimPlan === null || this.claimPlan === undefined) {
        this.submittedClaims = [];
        this.totalCountSubmitted = 0;
        return;
      }
      if (options && options.itemsPerPage) {
        this.tableOptions = options;
      }
      let isPredetermined;
      // console.log(this.claimPlan, searchParams, this.searchParams);
      if (searchParams) {
        this.searchParams = searchParams;
        // console.log(this.tableOptions);

        if (searchParams.submissionType === "Predetermination") {
          isPredetermined = true;
        } else if (searchParams.submissionType === "Regular Submission") {
          isPredetermined = false;
        }
      }
      try {
        this.loading = true;
        const data = (
          await this.searchClaims({
            planIdentityId: this.claimPlan.Id,
            submissionId: this.searchParams.submissionId,
            submissionDates: this.customSelectedDateRange.length
              ? this.customSelectedDateRange
              : this.selectedDateRange,
            expenseDates: this.searchParams.dates || [],
            paymentDates: this.searchParams.paymentDates || [],
            patient: this.searchParams.patient,
            status: this.searchParams.status,
            coverages: this.searchParams.coverages
              ? [
                  ...new Set(
                    this.searchParams.coverages.map((o) => o.BenefitId)
                  ),
                ]
              : [],
            claimedAmount: this.searchParams.claimedAmount,
            claimedAmountRange: this.searchParams.claimedAmountRange,
            selectAmountRange: this.searchParams.selectAmountRange,
            claimedExpense: this.searchParams.claimedExpense,
            userType: this.searchParams.userType,
            itemsPerPage: this.tableOptions.itemsPerPage
              ? this.tableOptions.itemsPerPage
              : 20,
            page: this.tableOptions.page,
            sortBy: this.computeSortBy(),
            sortDesc: this.computeSortDesc(),
            memberIdentityId: this.memberIdentityId,
            isPredetermined: isPredetermined,
            flags: this.searchParams.selectedFlags,
            cheque: this.searchParams.cheque,
            batchNumber: this.searchParams.batchNumber,
            payee: this.searchParams.payee,
            paymentAmount: this.searchParams.paymentAmount,
            paymentAmountRange: this.searchParams.paymentAmountRange,
            selectPaymentAmountRange:
              this.searchParams.selectPaymentAmountRange,
            totalPaid: this.searchParams.totalPaid,
            totalPaidRange: this.searchParams.totalPaidRange,
            selectTotalPaidRange: this.searchParams.selectTotalPaidRange,
            memberGroups: this.selectedMemberGroups,
            providers: this.searchParams.providers
              ? [...new Set(this.searchParams.providers.map((o) => o.Id))]
              : [],
            memberCertificate: this.searchParams.memberCertificate,
          })
        ).data;
        // this.submittedClaims = this.mockSubmittedClaims.value;
        // this.totalCountSubmitted = this.mockSubmittedClaims["@odata.count"];
        this.submittedClaims = data.value;
        this.totalCountSubmitted = data["@odata.count"];
        // this.totalCountPaid = this.paidClaims.length;
        if (!options) {
          this.$refs.sst && this.$refs.sst.resetTableOptions();
        }
      } catch (error) {
        this.loading = false;
        this.error = error;
        // console.log(error);
        // this.submittedClaims = [];
        // ==== Temporary mock claims data
        // this.submittedClaims = this.mockSubmittedClaims.value;
        // this.totalCountSubmitted = this.mockSubmittedClaims["@odata.count"];
        // this.paidClaims = this.mockPaidClaims;
        // this.totalCountPaid = this.mockPaidClaims.length;
      } finally {
        this.loading = false;
      }
    },
    computeSortBy() {
      if (this.tableOptions.sortBy && this.tableOptions.sortBy.length > 0) {
        return this.tableOptions.sortBy[0];
      }
      return "Timestamp";
    },
    computeSortDesc() {
      if (this.tableOptions.sortDesc && this.tableOptions.sortDesc.length > 0) {
        return this.tableOptions.sortDesc[0];
      }
      return "desc";
    },
    setPrintItems({ headers, items, title }) {
      if (headers && items && title) {
        this.claimsToPrint = items;
        this.printoutTableHeaders = headers;
        this.printoutTitle = title;
      }
    },
    setPrintPreData({ headers, item, title }) {
      if (headers && item && title) {
        this.claimToPrintPre = item;
        this.printoutTableHeadersPre = headers;
        this.printoutTitlePre = title;
      }
      this.predeterminationPrintDialog = true;
    },
    setPrintEobData({ headers, item, title }) {
      if (headers && item && title) {
        this.claimToPrintEob = item;
        this.printoutTableHeadersEob = headers;
        this.printoutTitleEob = title;
      }
      this.eobPrintDialog = true;
    },
    async printEob() {
      // console.log("##############################################")
      let filename = this.claimToPrintEob.Identifier;
      // await new Promise((resolve) => setTimeout(resolve, 1000));
      let el = document.getElementById("print-claims-eob");
      console.log(el);
      await document.fonts.ready;
      console.log("font status: ", document.fonts.ready);
      let opt = {
        margin: [0.1, 0.4, 0.2, 0.4],
        filename: filename,
        pagebreak: { avoid: "eob-child", mode: "css", before: "#page2el" },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        html2canvas: { scale: 4 },
      };
      const _this = this;
      html2pdf()
        .from(el)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(100);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() / 2.3,
              pdf.internal.pageSize.getHeight() - 0.2
            );
          }
        })
        .outputPdf()
        .save(`${filename}.pdf`)
        .then(async function () {
          _this.eobPrintDialog = false;
        });
    },
    async printPredetermination() {
      // console.log("##############################################")
      let filename = this.claimToPrintPre.Identifier;
      // await new Promise((resolve) => setTimeout(resolve, 1000));
      let el = document.getElementById("print-claims-pre");
      console.log(el);
      let opt = {
        margin: [0.1, 0.4, 0.2, 0.4],
        filename: filename,
        pagebreak: { mode: "avoid-all", before: "#page2el" },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        html2canvas: { scale: 4 },
      };
      const _this = this;
      html2pdf()
        .from(el)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(100);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() / 2.3,
              pdf.internal.pageSize.getHeight() - 0.2
            );
          }
        })
        .outputPdf()
        .save(`${filename}.pdf`)
        .then(async function () {
          _this.predeterminationPrintDialog = false;
        });
    },
    printSelected() {
      this.generatePrintout = true;
    },
    async printClaims() {
      let filename = this.selectedDateRange
        ? "ClaimHistory " +
          this.selectedDateRange[0].replace("/", "-") +
          " - " +
          this.selectedDateRange[1].replace("/", "-")
        : "ClaimHistory - All";
      let el = document.getElementById("print-claims");
      let opt = {
        margin: [0.1, 0.4, 0.2, 0.4],
        filename: filename,
        pagebreak: { mode: "avoid-all", before: "#page2el" },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
        html2canvas: { scale: 4 },
      };
      const _this = this;
      html2pdf()
        .from(el)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(100);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() / 2.3,
              pdf.internal.pageSize.getHeight() - 0.2
            );
          }
        })
        .outputPdf()
        .then(async function (pdf) {
          _this.generatePrintout = false;
          const base64 = btoa(pdf);
          _this.printFileFromBase64([base64], "pdf");
        });
    },
    reset(v) {
      // console.log("reset called");
      this.resetSearch = false;
      this.loading = false;
      this.searchParams = {};
      this.selectedDateRange = this.$helpers.dateRangesMonths(6);
      this.customSelectedDateRange = [];
      this.isCustomDateRange = false;
      if (
        this.memberIdentityId !== null &&
        this.memberIdentityId !== undefined
      ) {
        this.onSearch();
      } else {
        this.claimPlan = null;
      }
    },
    // previewProof(proof) {
    //   window.open(`#/proofs/${proof.Id}`, "_blank");
    // },
    // async previewProof({proof, submissionId}) {
    //   // this.loading = true;
    //   console.log("preview-proof", proof);
    //   proof.UploadName = `${submissionId} - ${proof.ClaimLines[0] + 1}-${proof.ProofType}`;

    //   // const getFileBase64 = (fileSegment) => {
    //   //   // eslint-disable-next-line no-async-promise-executor, no-unused-vars
    //   //   return new Promise(async (resolve, reject) => {
    //   //     try {
    //   //       let file = (await this.getFile(fileSegment.PhysicalFileId)).data;
    //   //       if (file[0] === '"') file = file.slice(1, -1);
    //   //       fileSegment.Base64 = file;
    //   //       fileSegment.FileExtension = this.$helpers.fileExtension(
    //   //         fileSegment.FileName
    //   //       );
    //   //       resolve(fileSegment);
    //   //     } catch (error) {
    //   //       reject(error);
    //   //     }
    //   //   });
    //   // };

    //   // try {
    //   // await Promise.all(proof.FileSegments.map((fs) => getFileBase64(fs)));
    //   // this.fileItems = proof;
    //   // this.preview = true;

    //   for (const file of proof.FileSegments) {
    //     try {
    //       this.loading = true;

    //       let base64File = (await this.getFile(file.PhysicalFileId)).data;
    //       if (base64File[0] === '"') {
    //         base64File = base64File.slice(1, -1);
    //       }
    //       file.Base64 = base64File;
    //       file.FileExtension = this.$helpers.fileExtension(file.FileName);
    //       let blob = null;
    //       if (file.FileExtension.toLowerCase() === "pdf") {
    //         blob = this.b64toBlob(base64File, "application/pdf");
    //       } else if (
    //         file.FileExtension.toLowerCase() === "jpg" ||
    //         file.FileExtension.toLowerCase() === "jpeg"
    //       ) {
    //         blob = this.b64toBlob(base64File, "image/jpeg");
    //       } else if (file.FileExtension.toLowerCase() === "txt") {
    //         blob = this.b64toBlob(base64File, "text/plain");
    //       }
    //       if (blob !== null) {
    //         const url = URL.createObjectURL(blob);
    //         const w = window.open(url, "_blank");
    //         const everythingLoaded = setInterval(() => {
    //           console.log("interval 10 passed: ", w.document.readyState);
    //           if (/loaded|complete/.test(w.document.readyState)) {
    //             clearInterval(everythingLoaded);
    //             w.document.title = proof.UploadName;
    //             const newDiv = w.document.createElement("div");
    //             const newContent = w.document.createTextNode(proof.UploadName);
    //             newDiv.style = "font-size:20px;margin-left:auto;margin-right:auto;background-color:white;color:black;margin-top:20px;";
    //             newDiv.appendChild(newContent);
    //             w.document.body.prepend(newDiv);
    //           }
    //         }, 100);
    //       }

    //       // window.open(
    //       //   `#/proofs/${encodeURIComponent(
    //       //     proof.UploadName
    //       //   )}/${encodeURIComponent(file.FileName)}/${file.PhysicalFileId}`,
    //       //   "_blank"
    //       // );
    //     } catch (error) {
    //       this.error = error;
    //     } finally {
    //       this.loading = false;
    //     }
    //   }
    //   // } catch (error) {
    //   //   console.log(error);
    //   // } finally {
    //   //   this.loading = false;
    //   // }
    // },
    // b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    //   const byteCharacters = atob(b64Data);
    //   const byteArrays = [];

    //   for (
    //     let offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     const slice = byteCharacters.slice(offset, offset + sliceSize);

    //     const byteNumbers = new Array(slice.length);
    //     for (let i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }

    //     const byteArray = new Uint8Array(byteNumbers);
    //     byteArrays.push(byteArray);
    //   }

    //   const blob = new Blob(byteArrays, { type: contentType });
    //   return blob;
    // },
    closePreview() {
      this.preview = false;
      this.fileItem = null;
    },
    newClaimSubmission(coverageType) {
      if (
        this.memberIdentityId !== null &&
        this.memberIdentityId !== undefined
      ) {
        this.$router.push({
          name: "memberClaimSubmission",
          params: {
            coverageType: coverageType,
            memberId: this.memberIdentityId,
          },
        });
      } else {
        this.$router.push({
          name: "claimSubmission",
          params: { coverageType: coverageType },
        });
      }
    },
  },
};
</script>
<style scoped>
.input-label {
  font-size: 14px;
  font-weight: 600;
}
.note-text {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.1;
}
.group-tabs >>> .v-tabs-items {
  background-color: transparent !important;
}
.v-tab--active.v-tab {
  background-color: var(--primary) !important;
}
.v-tab {
  background-color: grey !important;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.claim-btn {
  font-weight: 600 !important;
}
.claim >>> .v-btn__content {
  max-width: 180px;
  white-space: normal !important;
}
.v-btn--outlined {
  border: 2px solid;
}
.search >>> input {
  font-size: 14px !important;
}
.subtitle {
  font-size: 14px;
}
.v-tooltip__content {
  max-width: 250px !important;
}
</style>
